import React, { FC } from "react";
import { Button, InputField } from "../../forms";
import { ModalPropsDTO } from "../../../typings/generic";
import { useStateGetter } from "../../../hooks/statehooks/UseStateGettersHook";
import { useForm } from "react-hook-form";
import { emailReg, numReg, textReg } from "../../../utils/regex";
import { ListPicker } from "../../generic/ListPicker";
import { usePickerhook } from "../../../hooks/usePickerhook";
import { onAddDept } from "../../../services/department";
import { toast } from "react-toastify";
import { useStateSetter } from "../../../hooks/statehooks/UseStateSettersHook";
import { useOrganizationHook } from "../../../hooks/useOrganizationHook";
import Datepicker from "../../generic/Datepicker";
import useDepartmentHook from "../../../hooks/useDepartmentHook";
import useEmployeeHook from "../../../hooks/useEmployeeHook";
import usePositionHook from "../../../hooks/usePositionHook";
import { contractTypes } from "../../../constant/data";

const AddEmployee = (props: any) => {
  var { control, handleSubmit, watch } = useForm();
  const companypicker = usePickerhook();
  const empoymentdatepick = usePickerhook();
  const contracttypePickhook = usePickerhook();
  const positionPickhook = usePickerhook();
  const departmentPickhook = usePickerhook();
  const { selectedOrgDepts } = useDepartmentHook();
  const { allorgPositions } = usePositionHook();
  const { setLoading } = useStateSetter();
  const { AddEmployee } = useEmployeeHook();
  const watchedFields = watch(["firstname", "email", "lastname", "phone"]);
  const { SelectedOrg, config } = useStateGetter();
  const { UserOrgs } = useOrganizationHook();
  const areFieldsFilled = watchedFields.every(
    (field) =>
      field !== "" &&
      field !== undefined &&
      departmentPickhook.pickedRole &&
      positionPickhook.pickedRole &&
      contracttypePickhook.pickedRole
  );
  const onSubmit = async (data: any) => {
    var postdata = {
      firstName: data.firstname,
      lastName: data.lastname,
      department: departmentPickhook.pickedRole.name,
      phoneNumber: data.phone,
      email: data.email,
      deptID: departmentPickhook.pickedRole.code,
      positionID: positionPickhook.pickedRole.code,
      contractType: contracttypePickhook.pickedRole.code,
      organizationID: SelectedOrg.id,
    };

    setLoading(true);
    try {
      await AddEmployee(postdata);
      props.show(false);
      props.refresh();
    } catch (e: any) {
      toast.error(e);
    }
  };
  return (
    <>
      <div className="ModalContainer shadow ">
        <div className=" flex flex-col    rounded-[8px] bg-white w-[40vw] p-4 ">
          <p className="font-semibold self-start text-sm ">Add Employee</p>
          <div className=" grid grid-cols-2 gap-4  	 ">
            <InputField
              name="firstname"
              title="Firstname"
              placeholder={"Firstname"}
              control={control}
              rules={{
                required: "First name is required",
                pattern: {
                  value: textReg,
                  message: "Invalid first name",
                },
              }}
            />
            <InputField
              name="lastname"
              title="Lastname"
              placeholder={"lastname"}
              control={control}
              rules={{
                required: "last name is required",
                pattern: {
                  value: textReg,
                  message: "Invalid last name",
                },
              }}
            />

            <InputField
              name="email"
              title="Email Address"
              placeholder={"Enter Email Address"}
              control={control}
              rules={{
                required: "Email Address is required",
                pattern: {
                  value: emailReg,
                  message: "Invalid Email Address",
                },
              }}
            />

            <InputField
              name="phone"
              title="Phone number"
              placeholder={"Enter phone number"}
              control={control}
              rules={{
                required: "Phone number is required",
                pattern: {
                  value: numReg,
                  message: "Invalid phone number",
                },
              }}
            />

            <ListPicker
              fullwidth
              hook={positionPickhook}
              title="Position"
              list={allorgPositions.map((i: any) => {
                return { name: i.positionTitle, code: i.id };
              })}
            />
            <ListPicker
              fullwidth
              hook={contracttypePickhook}
              title="Contract Type"
              list={contractTypes}
            />

            <ListPicker
              fullwidth
              hook={departmentPickhook}
              title="Department"
              list={selectedOrgDepts.map((i) => {
                return { name: i.deptName, code: i.id };
              })}
            />
            <Datepicker
              defaultvalue={{ code: new Date(), name: new Date().toDateString }}
              hook={empoymentdatepick}
              title="Employment date"
            />
          </div>

          <div className=" flex justify-center items-center w-full gap-6">
            <Button
              outlined
              text="Cancel"
              onBtnClick={() => {
                props.show(false);
              }}
            />

            <Button
              disabled={!areFieldsFilled}
              text="Add Employee"
              onBtnClick={handleSubmit(onSubmit)}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default AddEmployee;
